import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Progression, ResponseProgression, UpdateTrophy } from 'app/shared/models/Progression/progression';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressionService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getProgression(): Observable<Progression> {
    return this.http.get<Progression>(`${environment.apiUrl}/Progression`);
  }

  getProgressionLicence(all: boolean): Observable<ResponseProgression> {
    return this.http.get<ResponseProgression>(`${environment.apiUrl}/Progression/licence?all=${all}`);
  }
  getProgressionTrophie(): Observable<UpdateTrophy> {
    return this.http.get<UpdateTrophy>(`${environment.apiUrl}/Progression/trophies`);
  }

  getProgressionImg(id: any): Observable<string> {
    return this.http.get<string>(`${environment.apiUrl}/Progression/image/${id}`);
  }

  getProgressionBackground(): Observable<string> {
    return this.http.get<string>(`${environment.apiUrl}/Progression/background`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateProgressionTrophy(trophy: UpdateTrophy) {
    return this.http.put(`${environment.apiUrl}/Progression/trophies`, trophy);
  }
}
